const offerStatusTypes = [
    {
        name: "PENDING",
        value: 1,
        color: 'orange'
    },
    {
        name: "DECLINED",
        value: 2,
        color: 'red'
    },
    {
        name: "ACCEPTED",
        value: 3,
        color: 'green'
    }
];

export default offerStatusTypes;